function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "l-line",
  d: "M10.7,28c5.1-4,9-23.9,18.8-16.3C32.6,5,22.7,1,17.7,8.9c-5.6,6.3-4.9,14.6-13,19.8C5.1,28.7,9.3,28.7,10.7,28z "
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "l-base",
  d: "M30,29.2c-1-2-2.5,1.3-6.2,1.3C20.3,32-3.9,25,3.1,35.5C5,28,33.4,43.4,30,29.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "upeer",
  d: "M78.1,18.8c-0.6-0.6-5.3,7.6-5.8,3.5c-0.1-1.2,5.4-5.5-1.1-7.7c2.7-3.4-4-7.3-3.2-0.8c5.1,1-6.1,15.8-7.6,7.8 c2.7,3,9.5-7.5,2.7-6.9c-3.7-0.4-10.7,15.2-13.1,6.9c6.8,3.3,8.2-15.9-2.7-2.1c1.2-3.1-0.7-7.9-6.3-2.2C45,5.4,31.9,30.8,32.6,21 c0.1-0.5,0.1-0.9,1.6-5c0.2-6.2-6.8,11.9-7.1,4.6c-0.2-1.6,2.8-4.2,1.4-5.8c-1,0.2-9.3,10.6-3.5,13c1.6,0,3.8-2.1,4.3-4.9 c-0.6,1.1,0.2,8.1,4.6,3.8c-1.4,1.9-2.1,10.6,2.8,7.1c-0.9-2.8,1-6.5,1.4-10.3C38,24.3,38,23.8,38,25.6h0c0.7,4.6,6.3,1.6,8.1-2.7 c-0.9,5.7,6.7,7.4,10.3,0.7c2.2,10.3,11.4,1.3,14.3-7.9c1.5,1.1,0.1,2-1.4,5.3C64.4,30.4,74.8,30.1,78.1,18.8z M62.1,18.4 c0.1,0.2,1.7-2.9,2.2-1.4c-0.3,0.4-1,2.7-2.9,2.6C61.5,19.1,61.8,18.8,62.1,18.4z M51.7,18.4c0.1,0.2,1.7-2.9,2.2-1.4 c-0.3,0.4-1,2.7-2.9,2.6C51.2,19.1,51.4,18.8,51.7,18.4z M45,18.5c-1.4,7.7-9.4,5.2-0.7-1.7C44.8,17,45.2,16.9,45,18.5z"
});

function SvgLupeerText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_1_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 40",
    style: {
      enableBackground: "new 0 0 80 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupeerText);
export default __webpack_public_path__ + "static/media/lupeer-text.54857257.svg";
export { ForwardRef as ReactComponent };